<!--
  Used by non iso bps. By default is loaded by ActionDownloadEvidencesOptions
  <ActionDownloadCurrent
    size='small'
    :unit="QUnit"
    color="primary",
    activator_icon="mdi-download"
    loading=false
  />
-->

<template>
  <div class="vcenter" v-if="show_action">
    <v-progress-circular
      v-if="loading"
      indeterminate
      :color="color"
      :size="size == 'small' ? 20 : 30"
    />
    <v-icon
        v-else
      :color="color"
      :small="size == 'small'"
      :large="size == 'large'"
      @click="handle_evidence"
      :disabled="disabled || !unit.current_state_document.value"
    >
      {{ activator_icon }}
    </v-icon>
  </div>
</template>
  
  
<script>
  import { downloadFile } from '@/utils/browserfiles';
  import QUnitAPI from '@/api/QUnit';
  import QUnit from '@/qunit/QUnit';

  export default {
    name: "ActionDownloadCurrent",
  
    props: {
      size: { default: 'small' },
      unit: { required: true },
      color: {type: String, default:"primary"},
      loading: {type: Boolean, default: false},
      activator_icon:{
        type: String,
        required: false,
        default: 'mdi-download'
      },
      disabled: Boolean
    },
    
    computed: {
      show_action() {
        // :disabled="!unit.current_state_document.value"
        return (this.unit.current_state_document||{}).value;
      },
    },

    methods: {
      async handle_evidence() {
        this.click();
        this.$emit('loading_start');
        const row = this.unit.current_state_document;
        const title = row.downloable_title || row.title || row.filename;
        const data = await QUnitAPI.getQUnitFile(
          this.unit._protected.centro,
          row.qunit_id,
          row.attribute,
          row.value,
          row.version,
          title,
          row.pmethod
        )
        downloadFile(data, title);
        this.$emit('loading_stop');
      },
  
      async update_qunit_after() {
        const updated_data = await QUnitAPI.getQUnit(this.unit._protected.centro, this.unit.uid);
        let new_qunit = new QUnit(updated_data);
        this.$emit('update', new_qunit);
      },

      click() {
        this.$emit('clicked');
      },
    },
  };
</script>
  
